import { Breadcrumbs, Text } from '@mantine/core';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function AppBreadcrumb(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const crumbs = location.pathname.split('/').filter((crumb) => crumb !== '');

  const handleCrumbClick = (crumb, index) => {
    const path = `/${crumbs.slice(0, index + 1).join('/')}`;
    
    if (index === crumbs.length - 1) {
      // If it's the last crumb (current page), force a reload
      window.location.reload();
    } else {
      // Otherwise navigate normally
      navigate(path);
    }
  };

  return (
    <div>
      <Breadcrumbs separator="/" sx={{ fontSize: 14 }}>
        <Text 
          component="a" 
          onClick={() => navigate('/')}
          sx={{ cursor: 'pointer' }}
        >
          Home
        </Text>
        {crumbs?.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <Text 
              key={index} 
              tt={'capitalize'}
              component="a"
              onClick={() => handleCrumbClick(crumb, index)}
              sx={{ 
                cursor: 'pointer',
                fontWeight: isLast ? 500 : 'normal'
              }}
            >
              {crumb}
            </Text>
          );
        })}
      </Breadcrumbs>
    </div>
  );
}

export default AppBreadcrumb;